<template>
  <BaseModal :title="modalTitle" :value="open" @close="close" headerClass="py-3">
    <template>
      <AddEditCategoryForm @onSuccess="close"/>
    </template>
  </BaseModal>
</template>

<script>
import { translations } from '@/mixins';
import BaseModal from '@/components/V2/Modals/BaseModal.vue';
import AddEditCategoryForm from './AddEditCategoryForm.vue';

export default {
  name: 'CategoriesModal',

  components: {
    BaseModal,
    AddEditCategoryForm,
  },

  mixins: [translations],

  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    modalTitle () {
      return this.translate('Add Category');
    },

    open () {
      return this.isOpen;
    },
  },

  methods: {
    close () {
      this.$emit('close');
      this.$emit('getCategories');
    },
  },
};
</script>
